import axios from 'axios';
import store from '../store';

function getReplacedDomain(subdomain: string): string {
    if (window.location.hostname === 'localhost') {
        return `http://${subdomain}.creace.localhost`;
    }

    return window.location.origin.replace(/(https?:\/\/)(.+?)?\./, `$1${subdomain}.`);
}

export const api = axios.create({
    baseURL: (process.env.VUE_APP_BASEURL ?? getReplacedDomain('api')) + '/v1',
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.isAxiosError) {
            return Promise.reject(error);
        }

        if (error.response.status === 401) {
            store.commit('setToken', null);
        }
    },
);

export function setApiToken(token: string): void {
    api.defaults.headers = {
        ...(api.defaults.headers || {}),
        Authorization: `Bearer ${token}`,
        'X-App-Id': 'io.creace.app',
    };
}
